import {Button} from 'components/ui/button';

function ErrorBanner() {
  return (
    <div className="flex flex-1 flex-col items-center justify-center bg-background px-6 py-12">
      {/* Animated error icon */}
      <div className="relative mb-8">
        <div className="absolute inset-0 animate-ping rounded-full bg-destructive/20" />
        <div className="relative flex h-24 w-24 items-center justify-center rounded-full bg-linear-to-br from-destructive/10 to-destructive/5 shadow-lg ring-1 ring-destructive/20">
          <svg
            className="h-12 w-12 text-destructive"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-md text-center">
        <h1 className="mb-3 text-3xl font-bold tracking-tight text-foreground">
          Something went wrong
        </h1>
        <p className="mb-8 text-base leading-relaxed text-muted-foreground">
          We couldn't display this page at this time. Please try again later or
          head back to the home page.
        </p>

        {/* Actions */}
        <div className="flex flex-col items-center gap-3 sm:flex-row sm:justify-center">
          <Button asChild size="lg">
            <a href="/">Back to Home</a>
          </Button>
          <Button
            variant="outline"
            size="lg"
            onClick={() => window.location.reload()}
          >
            Try Again
          </Button>
        </div>
      </div>

      {/* Decorative background elements */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -right-20 -top-20 h-64 w-64 rounded-full bg-linear-to-br from-muted/40 to-transparent blur-3xl" />
        <div className="absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-linear-to-tr from-muted/40 to-transparent blur-3xl" />
      </div>
    </div>
  );
}

export default ErrorBanner;
